module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-empty"
  }, [_c('img', {
    attrs: {
      "src": require("../images/login/empty.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-empty__text"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e5497b8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e5497b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Blocked.vue
// module id = 818
// module chunks = 0